import PropTypes from 'prop-types';
import React from 'react';

const LogoMultiSites = ({ title, twoLines }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='650'
      height='77.54'
      viewBox='0 0 650 77.54'
    >
      <polyline
        className='cls-11'
        points='12.49 48.36 12.49 55.28 47.05 73.54 58.97 67.71'
      />
      <polyline className='cls-11' points='84.9 36.08 84.9 57.8 82.6 60.95' />
      <path
        className='cls-11'
        d='M63.59,47.25s-12.28,6.74-14.37,6.75c-4.13.02-31.87-15.64-43.7-22.04-2.04-1.11-2.02-3.92.03-5L48.54,4.35c.88-.46,1.95-.47,2.85-.02l41.91,21.2c1.97.99,2.15,3.62.35,4.86l-2.09,1.43'
      />
      <polyline
        className='cls-11'
        points='46.13 26.93 73.69 41.98 73.69 70.49'
      />
      {twoLines ? (
        <React.Fragment>
          <text className='formation-name' transform='translate(107.69 22)'>
            Formation
          </text>
          <text className='formation-name' transform='translate(107.69 49.18)'>
            {title}
          </text>
          <text
            className='by-ecolefrancaise'
            transform='translate(107.69 75.02) scale(1.03 1)'
          >
            Par L&apos;École Française
          </text>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <text className='formation-name' transform='translate(107.69 39.18)'>
            {title}
          </text>
          <text
            className='by-ecolefrancaise'
            transform='translate(107.69 65.02) scale(1.03 1)'
          >
            Par L&apos;École Française
          </text>
        </React.Fragment>
      )}
    </svg>
  );
};

LogoMultiSites.propTypes = {
  title: PropTypes.string,
  twoLines: PropTypes.bool,
};

export default LogoMultiSites;
